export default "__VITE_ASSET__BpPAi10u__"